import { render, staticRenderFns } from "./AuctionLocationInformationLink.vue?vue&type=template&id=035d929c&scoped=true&"
import script from "./AuctionLocationInformationLink.vue?vue&type=script&lang=js&"
export * from "./AuctionLocationInformationLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035d929c",
  null
  
)

export default component.exports